import { AxiosInstance } from 'axios';

interface IUserUpdateEmail {
  uuid: string;
  name: string;
}

export default (api: AxiosInstance) => ({
  updateUserEmail: (data: IUserUpdateEmail) => api.put('update-name', data),
});
